<template>
  <page :modifiers="['background-grey-pale']">
    <header-component
      :content-props="{
        hasUserMenu: true,
        hasSearch: true,
        hasDiscoverMenu: true,
        hasLibraryLink: true,
        hasHighlightsLink: true
      }"
    />

    <episode-header :shortcast="shortcast" :episode="episode" />
  </page>
</template>

<script>
import Page from "@/shared/page"
import HeaderComponent from "@/features/header/components/index.vue"
import EpisodeHeader from "pages/shortcast-episode-player/components/episode-header/episode-header"

export default {
  name: "ShortcastEpisodePage",
  components: {
    EpisodeHeader,
    Page,
    HeaderComponent
  },
  props: {
    shortcast: {
      type: Object,
      required: true
    },
    episode: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
.shortcast-episode-page {
  @include container;
  @import "app/assets/stylesheets/layouts/page_loader";
}
</style>
